import { render } from "./MapExample.vue?vue&type=template&id=1580bbe1"
import script from "./MapExample.vue?vue&type=script&lang=js"
export * from "./MapExample.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__